import { useContext } from 'react';

import Context from './Context';

function useParentWindow() {
  return useContext(Context);
}

export default useParentWindow;
